module.exports = require('./head');



/*****************
 ** WEBPACK FOOTER
 ** ./~/lodash/first.js
 ** module id = 967
 ** module chunks = 0
 **/